import React from "react";
import "./hospitalsSection.css";
import { FaHospitalAlt } from "react-icons/fa";

const hospitals = [
  {
    name: "CityCare Multispeciality Hospital",
    desc: "Advanced diagnostics and 24x7 emergency services in the heart of the city.",
    type: "Hospital",
    rating: 5,
  },
  {
    name: "Green Valley Clinic",
    desc: "A trusted name for family health, pediatric care, and women’s wellness.",
    type: "Clinic",
    rating: 4,
  },
  {
    name: "Sunrise Health Centre",
    desc: "Expert consultation and lab services under one roof.",
    type: "Clinic",
    rating: 3,
  },
  {
    name: "MetroLife Hospital",
    desc: "State-of-the-art facilities with ICU and surgical departments.",
    type: "Hospital",
    rating: 5,
  },
  {
    name: "Wellbeing Family Clinic",
    desc: "Your neighborhood clinic for general and preventive care.",
    type: "Clinic",
    rating: 4,
  },
  {
    name: "BlueRiver Heart Institute",
    desc: "Specialized cardiac care with modern surgical suites and 24/7 monitoring.",
    type: "Hospital",
    rating: 5,
  },
  {
    name: "Lotus Skin & Wellness Clinic",
    desc: "Dermatology, cosmetology, and personalized skin treatment plans.",
    type: "Clinic",
    rating: 4,
  },
  {
    name: "Heritage Children’s Hospital",
    desc: "Pediatric specialists and NICU with family-centered care approach.",
    type: "Hospital",
    rating: 5,
  },
  {
    name: "Harmony Eye Care",
    desc: "Laser treatments, cataract surgery, and complete vision services.",
    type: "Clinic",
    rating: 4,
  },
  {
    name: "NobleCare Orthopedic Hospital",
    desc: "Joint replacement, trauma care, and physiotherapy under one roof.",
    type: "Hospital",
    rating: 5,
  },
  {
    name: "Serenity Women's Health Clinic",
    desc: "Gynecology, fertility support, and holistic women’s wellness.",
    type: "Clinic",
    rating: 4,
  },
];


function HospitalsSection() {
  const highlyRatedHospitals = hospitals.filter((hospital) => hospital.rating >= 4);
  const mostRecommendedHospitals = hospitals.filter((hospital) => hospital.rating === 5);

  return (
    <section  id="hospitals_&_clinics" className="hospitals">
      <h2>Most Recommended & Highly Rated Hospitals</h2>
      <p className="hospitals-section-subtitle">
        Book appointments with verified, highly-rated hospitals and clinics instantly.
      </p>

      {/* Most Recommended Hospitals */}
      <div className="recommendation-section">
        <h3>Most Recommended Hospitals</h3>
        <div className="horizontal-scroll">
          {mostRecommendedHospitals.map((hospital, index) => (
            <div className="hospital-card" key={index}>
              <div className="hospital-logo">
                <FaHospitalAlt />
              </div>
              <div className="hospital-details">
                <div className="hospital-type">{hospital.type}</div>
                <h3>{hospital.name}</h3>
                <p>{hospital.desc}</p>
                <div className="hospital-rating">
                  <span>Rating: </span>
                  {Array.from({ length: 5 }, (_, i) => (
                    <span key={i} className={`star ${i < hospital.rating ? "filled" : ""}`}>★</span>
                  ))}
                </div>
                <div className="hospital-buttons">
                  <button className="btn-outline-small">Know More</button>
                  <button className="btn-filled-small">Book Appointment</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Highly Rated Hospitals */}
      <div className="recommendation-section">
        <h3>Highly Rated Hospitals</h3>
        <div className="horizontal-scroll">
          {highlyRatedHospitals.map((hospital, index) => (
            <div className="hospital-card" key={index}>
              <div className="hospital-logo">
                <FaHospitalAlt />
              </div>
              <div className="hospital-details">
                <div className="hospital-type">{hospital.type}</div>
                <h3>{hospital.name}</h3>
                <p>{hospital.desc}</p>
                <div className="hospital-rating">
                  <span>Rating: </span>
                  {Array.from({ length: 5 }, (_, i) => (
                    <span key={i} className={`star ${i < hospital.rating ? "filled" : ""}`}>★</span>
                  ))}
                </div>
                <div className="hospital-buttons">
                  <button className="btn-outline-small">Know More</button>
                  <button className="btn-filled-small">Book Appointment</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HospitalsSection;
